import styled from 'styled-components';
import splash_exagon from 'assets/splash_exagon.svg';
import { ReactComponent as CurrencyIcon } from 'assets/icons/currency.svg';

export const Container = styled.div`
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  padding: 1.8rem 2.375rem;
  background: linear-gradient(to bottom, #0078d7 60%, #b3e5f3);

  &:before {
    content: '';
    position: absolute;
    top: 7%;
    right: 61%;
    z-index: -1;

    width: 250px;
    height: 250px;

    background-image: url(${splash_exagon});
    background-repeat: no-repeat;
    background-size: cover;

    top: 7%;
    right: 61%;
    z-index: -1;

    width: 250px;
    height: 250px;

    transform: rotate(218deg);
    opacity: 0.4;
  }

  &:after {
    content: '';
    position: absolute;
    top: 65%;
    right: 60%;
    z-index: -1;

    width: 250px;
    height: 250px;

    background-image: url(${splash_exagon});
    background-repeat: no-repeat;
    background-size: cover;

    transform: rotate(256deg);
    opacity: 0.6;
  }

  @media (max-width: 1170px) {
    position: fixed;

    top: unset;
    bottom: 0;
    max-height: min-content;
    width: 100%;

    flex-direction: row;
    padding: 1rem 1.8rem;

    border-radius: 0;

    background: #0078d7;

    box-shadow: 0 0 16px rgb(0 0 0 / 16%);
    &:before,
    &:after {
      display: none;
    }
  }
`;

export const Menu = styled.div`
  .menu__logo {
    width: 80px;
    cursor: pointer;

    display: block;

    margin: 0 auto;
  }

  .menu__item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    min-height: 55px;

    margin-top: 40px;
    cursor: pointer;

    .menu__item__icon {
      display: table;
      margin: 0 auto;
      width: 50px;
    }

    span {
      text-align: center;
      color: #fff;
      margin-top: 10px;
    }
  }

  @media (max-width: 320px) {
    .menu__item {
      span {
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 1170px) {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .menu__logo {
      display: none;
    }

    .menu__item {
      margin: 0;

      .menu__item__icon {
        width: 25px;
      }
    }
  }
`;

export const StyledCurrencyIcon = styled(CurrencyIcon)`
  width: 30px;
  align-self: center;
  margin: 0 auto;

  @media (max-width: 1170px) {
    width: 20px;
  }
`
